import React from "react";
import makeStyles from "@mui/styles/makeStyles";
import styles from "./styles.js";
import { Chip, Box, Typography } from "@mui/material/";
import { useTranslation } from "react-i18next";

import CheckIcon from "@mui/icons-material/Check";
import RotateLeftIcon from "@mui/icons-material/RotateLeft";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";

const AuditProgress = ({ alt, assigned, required }) => {
    const { t } = useTranslation();
    const classes = makeStyles(styles)();

    const ProgressIndicator = ({ name, value, icon }) => {
        return (
            <Box key={name} className={classes.auditProgressListContainer}>
                <Typography
                    className={classes.auditProgressCaption}
                    align="center"
                    variant="body2"
                >
                    {t(name)}
                </Typography>
                <Chip
                    variant="outlined"
                    className={classes.auditProgressValue}
                    icon={icon}
                    label={value}
                />
            </Box>
        );
    };

    return (
        <Box className={classes.auditProgressContainer}>
            <ProgressIndicator
                name={t("checked")}
                value={assigned}
                icon={
                    <CheckIcon className={classes.iconColor} fontSize="small" />
                }
            />
            <ProgressIndicator
                name={t("remaining")}
                value={required}
                icon={
                    <RotateLeftIcon
                        className={classes.iconColor}
                        fontSize="small"
                    />
                }
            />
            <ProgressIndicator
                name={t("unexpected")}
                value={alt}
                icon={
                    <ErrorOutlineIcon
                        className={classes.iconColor}
                        fontSize="small"
                    />
                }
            />
        </Box>
    );
};

export default AuditProgress;
